import { AixContentBody } from "@aix/ui"
import { EFeaturesVidmax } from "@aix/vidmax-shared/src/constants/pricing"
import { createFileRoute } from "@tanstack/react-router"
import { useAtomValue } from "jotai"
import { ReactElement, useEffect } from "react"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import { SeriesList } from "~/components/VidMax/SeriesList"
import { VideoList } from "~/components/VidMax/VideoList"
import { useFreemiumModalContext } from "~/context/useFreemiumModalContext"
import { navStyleAtom } from "~/context/jotai"
import AppLayout from "~/layouts/AppLayout"

const VidmaxPage = () => {
  const breadcrumbItems = [{ label: "Home", href: "/home" }, { label: "Automated Series" }]
  const { checkFeatureAccessAndShowUpgrade } = useFreemiumModalContext()
  const navStyle = useAtomValue(navStyleAtom)
  useEffect(() => {
    const hasAccess = checkFeatureAccessAndShowUpgrade(EFeaturesVidmax.AI_AUTOMATED_SERIES)
  }, [])
  return (
    <>
      {navStyle !== "twoTier" && <BreadcrumbBanner items={breadcrumbItems} />}

      <AixContentBody>
        <SeriesList />
      </AixContentBody>
    </>
  )
}

function AutomatedPageWrapper() {
  return (
    <AppLayout>
      <VidmaxPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/automated")({
  component: AutomatedPageWrapper,
})
